<template>
    <div class="x-ray-click-regions" tabindex="0" @keyup.enter.stop="onClick" @keydown.space.prevent="onClick"
        @click.stop="onClick">
    </div>
</template>
<script>
import { mapActions } from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";
import PdpProductMixin from "@/features/pdp/PdpProductMixin";

export default {
    name: "XRayClickRegions",
    mixins: [blockElementMixin, PdpProductMixin],
    props: {
        product: {
            type: Object,
            default: () => {
                return {}
            }
        },
        pageData: {
            type: Object,
        },
        flyerData: {
            type: Array,
        },
        blockRendered: {
            type: Object
        },
        pageRendered: {
            type: Object
        },
        flyerRendered: {
            type: Object
        },
        productRendered: {
            type: Object,
        },
        imageRendered: {
            type: Object,
        }
    },
    methods: {
        ...mapActions(['setXRayMode', 'setXRayData']),
        onClick(event) {
            const rect = this.$el.getBoundingClientRect();
            const clickX = event.clientX;
            const clickY = event.clientY;

            const products = (this.blockData && this.blockData.products) || [];
            let clickedProduct = null;

            // first check if the click is in any of the product regions
            for (const product of products) {
                const regions = product.clickRegions || [];
                for (const region of regions) {
                    if (this.isClickInRegion(clickX, clickY, region, rect)) {
                        clickedProduct = product;
                        break;
                    }
                }
                if (clickedProduct) break;
            }

            // if no product found, use the first product
            if (!clickedProduct && products.length === 1) {
                clickedProduct = products[0];
            }
            
            // if no product found, find the closest product by region center distance
            if (!clickedProduct && products.length > 0) {
                let closestProduct = null;
                let minDistance = Infinity;
                
                for (const product of products) {
                    const regions = product.clickRegions || [];
                    for (const region of regions) {
                        const regionCenterX = rect.left + (region.left + region.width / 2) / 100 * rect.width;
                        const regionCenterY = rect.top + (region.top + region.height / 2) / 100 * rect.height;
                        
                        const distance = Math.sqrt(
                            Math.pow(clickX - regionCenterX, 2) + 
                            Math.pow(clickY - regionCenterY, 2)
                        );
                        
                        if (distance < minDistance) {
                            minDistance = distance;
                            closestProduct = product;
                        }
                    }
                }
                
                if (closestProduct) {
                    clickedProduct = closestProduct;
                }
            }

            this.openXRayModal(clickedProduct);
        },
        openXRayModal(product) {
            const productData = product ? {
                ...product,
                blockData: this.blockData
            } : null;
            
            this.setXRayMode(true);
            this.setXRayData({
                block: {
                    raw: this.blockData,
                    rendered: {
                        block: this.blockRendered,
                        product: this.productRendered,
                        image: this.imageRendered,
                    }
                },
                page: {
                    raw: this.pageData,
                    rendered: this.pageRendered
                },
                flyer: {
                    raw: this.flyerData,
                    rendered: this.flyerRendered
                },
                product: productData
            });
        },
        isClickInRegion(clickX, clickY, region, containerRect) {
            if (!region || containerRect.width === 0 || containerRect.height === 0) return false;

            const regionLeft = containerRect.left + (region.left / 100) * containerRect.width;
            const regionTop = containerRect.top + (region.top / 100) * containerRect.height;
            const regionWidth = (region.width / 100) * containerRect.width;
            const regionHeight = (region.height / 100) * containerRect.height;
            const regionRight = regionLeft + regionWidth;
            const regionBottom = regionTop + regionHeight;

            const tolerance = 2;
            return clickX >= (regionLeft - tolerance) &&
                   clickX <= (regionRight + tolerance) &&
                   clickY >= (regionTop - tolerance) &&
                   clickY <= (regionBottom + tolerance);
        }
    },
}
</script>
<style lang="scss">
.x-ray-click-regions {
    position: absolute;
    z-index: 9999999;
    width: 100%;
    height: 100%;
    cursor: pointer;  
}

</style>